/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import BatchUpdateAbstract from 'cio/app-models/action-abstracts/batch-update';
import CampaignModel from 'cio/models/campaign';

interface WorkflowActionBatchAttributeUpdateArgs {
  action: ActionModel;
  actionAbstract: BatchUpdateAbstract;
  campaign: CampaignModel;
}

export default class WorkflowActionBatchAttributeUpdateDescription extends Component<WorkflowActionBatchAttributeUpdateArgs> {}
